// store/aiAnalysis.js

import axios from "axios";
import { eventBus } from "@/main";
import { isAIFeaturesEnabled } from "@/utils/environmentCheck";

export default {
  namespaced: true,

  state: {},

  mutations: {},

  actions: {
    fetchIncomeAnalysis({ commit }, payload) {
      return axios
        .get(
          `/api/report/analysisItem/${payload.clinicUrl}/${payload.branchUrl}`,
          {
            params: {
              startDt: payload.startDt,
              endDt: payload.endDt
            }
          }
        )
        .then(res => {
          return res;
        })
        .catch(err => {
          eventBus.$emit("apiError", err);
          throw err;
        });
    },

    // New recommendations API call
    fetchIncomeRecommendations({ commit }, payload) {
      // Disable AI features in production environment
      if (!isAIFeaturesEnabled()) {
        console.warn('AI recommendations are disabled in production environment');
        return Promise.reject(new Error('AI recommendations are not available in this environment'));
      }

      return axios
        .post(
          `/api/report/analysisItem/${payload.clinicUrl}/${payload.branchUrl}/recommendations`,
          {
            analyticsData: payload.analyticsData
          },
          {
            params: {
              startDt: payload.startDt,
              endDt: payload.endDt
            }
          }
        )
        .then(res => {
          return res;
        })
        .catch(err => {
          eventBus.$emit("apiError", err);
          throw err;
        });
    },

    // Patient analytics API call
    fetchPatientAnalytics({ commit }, payload) {
      return axios
        .get(
          `/api/report/patientAnalytics/${payload.clinicUrl}/${payload.branchUrl}`,
          {
            params: {
              startDt: payload.startDt,
              endDt: payload.endDt
            }
          }
        )
        .then(res => {
          return res;
        })
        .catch(err => {
          eventBus.$emit("apiError", err);
          throw err;
        });
    },

    // Patient analytics recommendations API call
    fetchPatientRecommendations({ commit }, payload) {
      // Disable AI features in production environment
      if (!isAIFeaturesEnabled()) {
        console.warn('AI recommendations are disabled in production environment');
        return Promise.reject(new Error('AI recommendations are not available in this environment'));
      }

      return axios
        .post(
          `/api/report/patientAnalytics/${payload.clinicUrl}/${payload.branchUrl}/recommendations`,
          {
            patientAnalysisResult: payload.patientAnalysisResult
          }
        )
        .then(res => {
          return res;
        })
        .catch(err => {
          eventBus.$emit("apiError", err);
          throw err;
        });
    },

    // Generate social media content API call
    generateSocialContent({ commit }, payload) {
      // Disable AI features in production environment
      if (!isAIFeaturesEnabled()) {
        console.warn('AI content generation is disabled in production environment');
        return Promise.reject(new Error('AI content generation is not available in this environment'));
      }

      return axios
        .post(
          `/api/ai/content`,
          {
            recommendation: payload.recommendation,
            clinicUrl: payload.clinicUrl,
            branchUrl: payload.branchUrl
          }
        )
        .then(res => {
          return res;
        })
        .catch(err => {
          eventBus.$emit("apiError", err);
          throw err;
        });
    }
  },
  getters: {}
};
